import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit"
import api from "../api/base"
import tokenSlice from "../state/token"
import applySlice from "../state/apply"

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    token: tokenSlice,
    apply: applySlice
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
